import { twMerge } from '@stereoagency/tailwind-config';
import React from 'react';
export default function DonationValueSwitch(param) {
    var options = param.options, renderDisplayValue = param.renderDisplayValue, onSelect = param.onSelect, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            '--grid-cols-count': options.length
        },
        className: twMerge('grid gap-3 grid-cols-2 grid-flow-row auto-rows-max md:grid-cols-[repeat(var(--grid-cols-count),1fr)]', className)
    }, options.map(function(opt) {
        return /*#__PURE__*/ React.createElement("button", {
            key: opt.value,
            type: "button",
            className: twMerge('p-4 rounded-full border border-subtle-700'),
            onClick: function onClick() {
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(opt.id);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "font-heading font-semibold text-center leading-snug"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "block text-body-base"
        }, renderDisplayValue(opt)), /*#__PURE__*/ React.createElement("span", {
            className: "block text-navigation-small uppercase"
        }, opt.label)));
    }));
}

//# sourceMappingURL=DonationValueSwitch.js.map